import React from 'react';
import styled from 'styled-components';
import { StyledInput } from '../../components/StyledInput'
import PropTypes from 'prop-types';
import { Icon } from '../../components/Icon';

const Container = styled.div`
  .x-icon {
    margin: 0.34em 0em 0em 0.34em;
  }
`;

const ErrorMessage = styled.div`
  color: red;
`;

const InputContainer = styled.div`
  max-width: 100%;
  height: 3em;
  width: 25em;
  float: left;
`;

const SelectSubscriptionName = (props) => (
  <Container>
    <InputContainer>
      <StyledInput
        onChange={props.onFieldChange}
        title={'Kirjoita liittymän nimi'}
        name={'subscriptionName'}
        backgroundColor={'#fafafa'}
        value={props.selectedSubscription.subscriptionName.value}
        largeText
      />
      {props.showErrors && !props.selectedSubscription.subscriptionName.valid && (
        <ErrorMessage>Kenttä ei voi olla tyhjä</ErrorMessage>
      )}
    </InputContainer>
    <Icon onClick={props.eraseCurrentSubscription} className={'x-icon'} name={'medium--x--gray'} />
  </Container>
)

SelectSubscriptionName.propTypes = {
  showErrors: PropTypes.bool,
  selectedSubscription: PropTypes.object,
  onFieldChange: PropTypes.func,
  eraseCurrentSubscription: PropTypes.func,
};

export default SelectSubscriptionName;
